module.exports = __webpack_public_path__ + "static/img/top.0a5445f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/top.gif
// module id = zS3g
// module chunks = 1